// extracted by mini-css-extract-plugin
export var form = "_ci-0";